module.exports = __webpack_public_path__ + "static/2front-you-2-d9ad82a86bd2f948a096bb51165688ac.png";